import Vue from "vue";
import Loading from "vuejs-loading-plugin";

Vue.use(Loading);
